/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect, useCallback } from "react";
import BgEvent from "../asset/img/bg-event.webp";
import { Link } from "react-router-dom";
import FloatingMenu from "../components/FloatingMenu";

const ITEMS_PER_PAGE = 9;

const Event = () => {
    const [datas, setData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    const fetchData = useCallback(async () => {
        try {
            const response = await fetch('https://cms.okoce.net/api/admin/events');
            if (!response.ok) {
                throw new Error('Gagal mengambil data event');
            }
            const result = await response.json();
            const filteredEvents = result.data.filter(event => event.published_at !== null);
            filteredEvents.sort((a, b) => new Date(a.date) - new Date(b.date));
            const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
            const endIndex = startIndex + ITEMS_PER_PAGE;
            const currentData = filteredEvents.slice(startIndex, endIndex);
            setData(currentData);
            setTotalPages(Math.ceil(filteredEvents.length / ITEMS_PER_PAGE));
        } catch (error) {
            setData([]);
        }
    }, [currentPage]);  // Add currentPage as a dependency

    useEffect(() => {
        fetchData();
    }, [fetchData, currentPage]);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    return (
        <>
            <div className="block w-full mt-32">
                <img className="mobile:w-full mobile:h-[12rem] lg:w-9/12 lg:h-[23rem] mx-auto" src={BgEvent} alt="header"></img>
            </div>
            <div className="grid mb-20 mobile:grid-cols-1 mobile:grid-flow-row lg:w-11/12 lg:mx-auto lg:grid-cols-3 lg:grid-flow-row lg:gap-y-12 lg:gap-x-0 lg:mt-24">
                {datas.map((data, index) =>
                    <div key={index} className="flex flex-col mx-auto w-5/6 max-md:ml-0 drop-shadow-xl max-md:w-full mobile:p-6 lg:p-0">
                        <div className="flex flex-col grow max-md:mt-10">
                            <img src={`${process.env.REACT_APP_API_URL}/${data.image}`} loading="lazy" className="w-full shadow-sm aspect-square" />
                            <div className="flex flex-col px-4 py-5 w-full bg-white shadow-sm">
                                <div className="relative group mb-2 mt-2 h-10">
                                    <div className="leading-7 text-black font-bold text-xl overflow-hidden line-clamp-2">
                                        {data.title}
                                    </div>
                                    <div className="absolute left-0 bottom-full mb-2 hidden w-full text-xs text-white bg-black p-2 rounded group-hover:block">
                                        {data.title}
                                    </div>
                                </div>
                                <div className="flex gap-5 justify-between mt-7 text-xs leading-5">
                                    <div className="flex flex-col">
                                        <div className="text-neutral-400 text-sm">{data.date}</div>
                                        <div className="mt-2.5 text-sky-700 text-lg">Rp{data.price.toLocaleString()}</div>
                                    </div>
                                    <div className="self-start mt-8 text-right text-[#e01f31] text-lg">
                                        {data.point} Points
                                    </div>
                                </div>
                                <Link to={`/event/${data.id}`}>
                                    <div className="justify-center items-center mt-6 px-16 py-5 text-base leading-5 text-center text-white bg-[#1c75ac] rounded-lg border-t border-dashed shadow-sm border-neutral-400 hover:bg-blue-700 max-md:px-5"> Beli Tiket
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            {/* Pagination Controls */}
            <div className="flex justify-center mt-8 py-8 mx-auto rounded-xl mobile:w-3/4 lg:w-1/2">
                <button
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    className="mx-1 py-2 border rounded bg-white text-[#1c75ac] mobile:w-full lg:w-8/12 hover:bg-[#1c75ac] hover:text-white"
                >
                    Sebelumnya
                </button>
                <button
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    className="mx-1 py-2 border rounded bg-white text-[#1c75ac] mobile:w-full lg:w-8/12 hover:bg-[#1c75ac] hover:text-white"
                >
                    Selanjutnya
                </button>
            </div>
            <FloatingMenu />{" "}
        </>
    );
}

export default Event;